import { Icon, SvgAlertTriangle, Text } from '@loomhq/lens';
import { Spacer } from '@loomhq/lens/dist/components';
import React from 'react';

import emptyTranscript from 'img/icons/empty-transcript.svg';
import shapeLoader from 'img/shape-loader.gif';

import styles from './styles.module.less';

const EmptySkeleton = ({ children, header, subHeader }) => {
  return (
    <div className={styles.emptyTranscript}>
      {children}
      <div className={styles.emptyTranscriptText}>
        {header && (
          <>
            <Text fontWeight="medium" alignment="center">
              {header}
            </Text>
            <Spacer bottom="xsmall" />
          </>
        )}
        {subHeader && <Text alignment="center">{subHeader}</Text>}
      </div>
    </div>
  );
};

const EmptyTranscript = ({ failed, empty }) => {
  if (failed) {
    return (
      <EmptySkeleton subHeader="The transcript was not able to be processed.">
        <Icon size={6} icon={<SvgAlertTriangle />} />
      </EmptySkeleton>
    );
  }

  if (empty) {
    return (
      <EmptySkeleton
        header="No Transcript"
        subHeader="Loom could not detect any audible speech in this video"
      >
        <img
          src={emptyTranscript}
          width="40px"
          height="40px"
          alt="no transcript"
        />
      </EmptySkeleton>
    );
  }

  return (
    <EmptySkeleton subHeader="The transcript is processing. Hang tight!">
      <img width="100px" height="100px" src={shapeLoader} alt="loading..." />
    </EmptySkeleton>
  );
};

export default EmptyTranscript;
